<template>
  <div class="breadcrumb">
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/' }" style="font-weight:none;color:#515151;">首页</el-breadcrumb-item>
    <el-breadcrumb-item v-for="(path,index) in paths" :key="index" :to="path.url" style="font-weight:none;color:#515151;">{{ path.name }}</el-breadcrumb-item>
  </el-breadcrumb>
  </div>

</template>

<script>
export default {
  props: ['paths']
}
</script>

<style scoped>
.breadcrumb{
/* background: #ffffff; */
padding:0 15px;
font-size: 19px;
}
</style>



// WEBPACK FOOTER //
// src/widgets/public/Breadcrumb.vue